import { isNil } from 'lodash'

import { usePlaceholder } from '../SchemaForm/hooks/usePlaceholder'

import { PreviewTextProps } from './interface'
import { PreviewWrapper } from './Wrapper'

export const PreviewText = ({
  value,
  dangerouslySetInnerHTML
}: PreviewTextProps) => {
  const placeholder = usePlaceholder()
  const text = `${value ?? placeholder}`

  return (
    <PreviewWrapper
      title={isNil(value) ? '' : text}
      dangerouslySetInnerHTML={
        dangerouslySetInnerHTML
          ? {
              __html: text
            }
          : undefined
      }
    >
      {text}
    </PreviewWrapper>
  )
}
